import { paymentApi } from '../apiClients';

export const downloadAccountReceiptByPaymentId = (id: string) =>
  paymentApi.getPaymentReceipt({ id }).then((res) => res.data.data.base64);
export const downloadVendorReceiptByPaymentId = (id: string) =>
  paymentApi.getPaymentVendorReceipt({ id }).then((res) => res.data.data.base64);
